enum RolesPocketSafe {
  ContentEditor = 'pocketsafe_content_editor',
  CustomerAdministrator = 'pocketsafe_customer_administrator',
  CustomerOnboardingAdministrator = 'PocketSafe Customer Onboarding Administrator',
  CustomerExitAdministrator = 'PocketSafe Customer Exit Administrator',
  SecurityOnline = 'pocketsafe_security_online',
  SecuritySupervisor = 'pocketsafe_security_supervisor',
  ActionLibraryAdministrator = 'pocketsafe_action_library_administrator',
  RopaAdministrator = 'ROPA Administrator',
}

export const EVERY_PS_ROLE = Object.values(RolesPocketSafe);

export default RolesPocketSafe;
